/*
 *
 * SummaryQuestions selectors
 *
 */

import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the SummaryQuestions state domain
 */

const selectSummaryQuestionsDomain = (state) =>
  state.get("summaryQuestions", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectSummaryQuestionsDomain, (state) =>
    state.get("isLoading")
  )
export const makeSelectQuestionTypes = () =>
  createSelector(selectSummaryQuestionsDomain, (state) =>
    state.get("questionTypes")
  )
export const makeSelectTotalQuestions = () =>
  createSelector(selectSummaryQuestionsDomain, (state) =>
    state.get("totalQuestions")
  )

/**
 * Default selector used by SummaryQuestions
 */

const makeSelectSummaryQuestions = () =>
  createSelector(selectSummaryQuestionsDomain, (subState) => subState.toJS())

export default makeSelectSummaryQuestions
export { selectSummaryQuestionsDomain }
